export const SAVE_ID_PHOTO = 'SAVE_ID_PHOTO'
export const RESET_ID_PHOTO = 'RESET_ID_PHOTO'

export const saveIDPhoto = (idPhoto) => ({ type: SAVE_ID_PHOTO, idPhoto })
export const resetIDPhoto = () => ({ type: RESET_ID_PHOTO })